import "./CSS/genericDrawer.scss";
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { SearchSelectors } from "../../redux/selectors";
import { DrawerType } from "../../constants";

const showBackBtnMenus = [DrawerType.HamburgerMenu, DrawerType.MyAccountArea];

const GenericDrawer = props => {
  const {
    header,
    className,
    children,
    isVisible,
    menu,
    componentRef,
    verticalTransition
  } = props;

  const searchActive = useSelector(SearchSelectors.searchActive);
  const [topSectionClass, setTopSectionClass] = useState("");

  useEffect(() => {
    setTopSectionClass(
      classNames({
        showBackBtn: !showBackBtnMenus.includes(menu) || searchActive
      })
    );
  }, [menu, searchActive]);

  const headerClasses = useMemo(
    () =>
      classNames("generic-drawer-header", {
        [topSectionClass]: !!topSectionClass
      }),
    [topSectionClass]
  );

  const drawerClasses = useMemo(
    () =>
      classNames("generic-drawer", `generic-drawer-${verticalTransition}`, {
        [`drawer-show-${verticalTransition}`]: isVisible,
        [`drawer-hide-${verticalTransition}`]: !isVisible,
        [className]: !!className
      }),
    [verticalTransition, isVisible, className]
  );

  return (
    <div ref={componentRef} className={drawerClasses}>
      <div className={headerClasses}>{header}</div>
      <div className="generic-drawer-content">{children}</div>
    </div>
  );
};

GenericDrawer.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
  className: PropTypes.string,
  isVisible: PropTypes.bool,
  menu: PropTypes.string.isRequired,
  componentRef: PropTypes.object,
  verticalTransition: PropTypes.string.isRequired
};

export default React.memo(GenericDrawer);
